var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 72,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2314 48.32C29.738 48.32 28.3834 48.0533 27.1674 47.52C25.9727 46.9653 24.9594 46.1653 24.1274 45.12L26.6234 42.624C27.0714 43.3067 27.7007 43.8507 28.5114 44.256C29.322 44.6613 30.2074 44.864 31.1674 44.864C32.0847 44.864 32.874 44.6933 33.5354 44.352C34.1967 44.0107 34.7087 43.5307 35.0714 42.912C35.4554 42.2933 35.6474 41.5787 35.6474 40.768C35.6474 39.9147 35.4554 39.1893 35.0714 38.592C34.7087 37.9947 34.1754 37.536 33.4714 37.216C32.7887 36.8747 31.9567 36.704 30.9754 36.704C30.5914 36.704 30.1967 36.736 29.7914 36.8C29.386 36.8427 29.0234 36.9173 28.7034 37.024L30.3354 34.912C30.7834 34.7413 31.2527 34.6027 31.7434 34.496C32.2554 34.368 32.746 34.304 33.2154 34.304C34.3674 34.304 35.402 34.5813 36.3194 35.136C37.258 35.6907 37.994 36.4693 38.5274 37.472C39.082 38.4533 39.3594 39.616 39.3594 40.96C39.3594 42.4107 39.018 43.6907 38.3354 44.8C37.6527 45.9093 36.7034 46.7733 35.4874 47.392C34.2714 48.0107 32.8527 48.32 31.2314 48.32ZM28.7034 37.024V34.848L34.6874 27.872L39.1034 27.776L32.8634 34.944L28.7034 37.024ZM25.2474 28.896V25.6H39.1034V27.776L35.9354 28.896H25.2474Z",
    fill: "#4E5667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.fd48e6a3300f426f4b2039444d486852.svg";
export { ForwardRef as ReactComponent };